import { select } from "d3-selection"
import { Component } from "react"
import PropTypes from "prop-types"

export const AXIS = PropTypes.shape({
  fn: PropTypes.func.isRequired,
  transform: PropTypes.string.isRequired,
  baseline: PropTypes.shape({
    x1: PropTypes.number.isRequired,
    x2: PropTypes.number.isRequired,
    y1: PropTypes.number.isRequired,
    y2: PropTypes.number.isRequired,
  }).isRequired,
})

class Axis extends Component {
  static propTypes = {
    fn: PropTypes.func.isRequired,
    transform: PropTypes.string.isRequired,
    axisStyle: PropTypes.object,
  }

  draw = () => {
    const { ref, props: { fn } } = this

    select(ref)
      .call(fn)
  }

  componentDidUpdate() {
    this.draw()
  }

  setRef = node => {
    this.ref = node
    this.draw()
  }

  render() {
    const { transform, axisStyle } = this.props
    return <g ref={this.setRef} className="axis" transform={transform} style={axisStyle} />
  }
}

export default Axis
